import { ComponentProps, Dispatch, SetStateAction } from 'react';
import { AnalyticsData } from '../../../../hooks/constants/Analytics';
import { ExercisePhase } from '../../@types/exercise-types';
import { PauseExerciseSessionResponse, StopExerciseSessionResponse } from '../../api/exercises-api';
import { useExerciseManagerContext } from '../../contexts/ExerciseManagerContext';
import ActiveSessionModal from './active-session-modal';
import ExerciseAnswersModal from './exercise-answers-modal';

interface ExerciseActivityModalsProps extends Pick<ComponentProps<typeof ExerciseAnswersModal>, 'session'> {
  reviewSessionId?: string;
  analyticsData?: AnalyticsData;
  phaseAction: ExercisePhase | undefined;
  onSessionPaused: (session: PauseExerciseSessionResponse) => void;
  onSessionFinished: (result: StopExerciseSessionResponse) => void;
  setPhase: Dispatch<SetStateAction<'launch' | 'activity' | 'progression' | undefined>>;
}

function ExerciseActivityModals({
  reviewSessionId,
  analyticsData,
  phaseAction,
  onSessionPaused,
  onSessionFinished,
  setPhase,
  session,
}: ExerciseActivityModalsProps): JSX.Element {
  const { medialink, onClose, module, studioGroup } = useExerciseManagerContext();

  return reviewSessionId ? (
    <ExerciseAnswersModal
      id="exercise-answers-modal"
      sessionId={reviewSessionId}
      analyticsData={analyticsData}
      medialink={medialink}
      onClose={onClose}
      module={module}
      studioGroup={studioGroup}
      title={medialink.name}
      session={session}
    />
  ) : (
    <ActiveSessionModal
      phaseAction={phaseAction}
      analyticsData={analyticsData}
      onSessionPaused={onSessionPaused}
      onSessionFinished={onSessionFinished}
      setPhase={setPhase}
    />
  );
}

export default ExerciseActivityModals;
